// === Click2Gro Admin Portal — Entry Point ===

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { installApiInterceptor } from './lib/api-interceptor';

// Resilient session handling for every API call: fresh token per call, refresh +
// retry on 401, and auto sign-out/redirect to login when the session is dead.
installApiInterceptor();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
